<template>
  <autocomplete
    :value="value"
    :items="items"
    :label="label || $t('product_categories.category')"
    :loading="loading"
    :clearable="clearable"
    :rules="rules"
    item-value="id"
    item-text="path"
    @input="$emit('input', $event === undefined ? null : $event)"
  />
</template>

<script>
import productCategoryService, { flattenCategories } from "@/services/productCategory";

/**
 * Izbor jedinstvene kategorije (podkategorije), prikazuje se putanja "Piće › Vode".
 * Sa `leaf-only` mogu se birati samo kategorije bez podkategorija.
 */
export default {
  name: "CategorySelect",
  props: {
    value: { type: [Number, String], default: null },
    label: { type: String, default: "" },
    clearable: { type: Boolean, default: true },
    leafOnly: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
  },
  data: () => ({ tree: [], loading: false }),
  computed: {
    items() {
      const all = flattenCategories(this.tree).filter((c) => c.active !== false);
      if (!this.leafOnly) {
        return all;
      }
      const parents = new Set(all.map((c) => c.parent_id));
      return all.filter((c) => !parents.has(c.id));
    },
  },
  async created() {
    this.loading = true;
    try {
      this.tree = await productCategoryService.getTree();
    } finally {
      this.loading = false;
    }
  },
};
</script>
